import { atomWithBroadcast } from './atomWithBroadcast';

/**
 * Non-trading days of a market, this is a list of formatted dates
 */
export type NonTradingDaysOfMarket = Array<string>;

export const nonTradingDaysAtom = atomWithBroadcast<Record<string, NonTradingDaysOfMarket>>('core/nonTradingDays', {});
